var $ = require('jquery');
require('jquery-match-height');

var MatchHeight = function MatchHeight($element, options) {
	var $properties = $('.property-list-item');
	if($properties.length) {
		$properties.matchHeight();
	}

	var $reviews = $('.reviews .review');
	if($reviews.length) {
		$reviews.matchHeight();
	}

	var $propertyDetails = $('.property-details .block');
	if($propertyDetails.length) {
		$propertyDetails.matchHeight();
	}

	var $cateringContacts = $('.catering-contacts > div');
	if($cateringContacts.length) {
		$cateringContacts.matchHeight();
	}

	var $activitySmall = $('.activity-small');
	if($activitySmall.length) {
		$activitySmall.matchHeight();
	}

	var $postItem = $('.post-list-item');
	if($postItem.length) {
		$postItem.matchHeight();
	}

	var $calendars = $('.calendar');
	if($calendars.length) {
		$calendars.matchHeight();
	}
}

module.exports = MatchHeight;